export const SEGMENTS = [
  {
    "id": "hospital-beds",
    "name": "Hospital Beds & Mattress",
    "tab": "Beds",
    "tagline": "ICCU, Fowler beds & mattresses",
    "products": [
      {
        "slug": "upgraded-motorized-iccu-bed-10-parts",
        "name": "Upgraded Motorized ICCU Bed (10 Parts)",
        "img": "/products/upgraded-motorized-iccu-bed-10-parts-cut.png",
        "specs": [
          "Platform divided in 10 parts",
          "Operated by actuator",
          "Head rest, knee rest, height adjustable, Trendelenburg & Reverse Trendelenburg position",
          "Head & leg board / split rail made of ABS materials",
          "Central locking castor",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 2220mm × W 1010mm × H 550mm–800mm (adjustable height)"
        ]
      },
      {
        "slug": "upgraded-manual-iccu-bed-10-parts",
        "name": "Upgraded Manual ICCU Bed (10 Parts)",
        "img": "/products/upgraded-manual-iccu-bed-10-parts-cut.png",
        "specs": [
          "Platform divided in 10 parts",
          "Manually operated",
          "Head rest, knee rest, height adjustable, Trendelenburg & Reverse Trendelenburg position",
          "Head & leg board / split rail made of ABS materials",
          "Mounted on medical grade castors, two with brakes",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 2220mm × W 1010mm × H 550mm–800mm (adjustable height)"
        ]
      },
      {
        "slug": "manual-iccu-bed-4-parts",
        "name": "Manual ICCU Bed (4 Parts)",
        "img": "/products/manual-iccu-bed-4-parts-cut.png",
        "specs": [
          "Platform divided in 4 parts",
          "Manually operated",
          "Head rest, knee rest, height adjustable, Trendelenburg & Reverse Trendelenburg position",
          "Head & leg board made of ABS materials",
          "Two having collapsible side rail",
          "Mounted on medical grade castor, two with brake",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 2220mm × W 1010mm × H 550mm–800mm (adjustable height)"
        ]
      },
      {
        "slug": "upgraded-motorized-fowler-bed-10-parts",
        "name": "Upgraded Motorized Fowler Bed (10 Parts)",
        "img": "/products/upgraded-motorized-fowler-bed-10-parts-cut.png",
        "specs": [
          "Platform divided in 10 parts",
          "Head rest, knee rest position",
          "Head & leg board / split rail made of ABS materials",
          "Mounted on medical grade castors, two with brakes",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 1980mm × W 1000mm × H 550mm"
        ]
      },
      {
        "slug": "upgraded-manual-fowler-bed-10-parts",
        "name": "Upgraded Manual Fowler Bed (10 Parts)",
        "img": "/products/upgraded-manual-fowler-bed-10-parts-cut.png",
        "specs": [
          "Platform divided in 10 parts",
          "Head rest, knee rest position",
          "Head & leg board / split rail made of ABS materials",
          "Mounted on medical grade castors, two with brakes",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 1980mm × W 1000mm × H 550mm"
        ]
      },
      {
        "slug": "deluxe-manual-fowler-bed-4-parts",
        "name": "Deluxe Manual Fowler Bed (4 Parts)",
        "img": "/products/deluxe-manual-fowler-bed-4-parts-cut.png",
        "specs": [
          "Platform divided in 4 parts",
          "Head rest, knee rest position",
          "Side rail made of aluminium, PP moulded collapsible / split railing",
          "Mounted on medical grade castors, two with brakes",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 2220mm × W 1010mm × H 600mm"
        ]
      },
      {
        "slug": "manual-fowler-bed-4-parts",
        "name": "Manual Fowler Bed (4 Parts)",
        "img": "/products/manual-fowler-bed-4-parts-cut.png",
        "specs": [
          "Platform divided in 4 parts",
          "Head rest, knee rest position",
          "Side rail made of aluminium, PP moulded collapsible railing",
          "Mounted on medical grade castors, two with brakes",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 2220mm × W 1010mm × H 600mm"
        ]
      },
      {
        "slug": "ripple-mattress",
        "name": "Ripple Mattress",
        "img": "/products/ripple-mattress-cut.png",
        "specs": [
          "Mattress made of hollow fibre, 15D siliconised",
          "Light weight, washable, both side usable",
          "Innovative channel concept & hygienic for breathability",
          "Fire resistant",
          "100% blue cotton cloth, weight 28 kgs",
          "Dimensions: L 1980mm × W 914mm"
        ]
      }
    ]
  },
  {
    "id": "bedside-furniture",
    "name": "Bedside Furniture",
    "tab": "Bedside",
    "tagline": "Lockers & overbed tables",
    "products": [
      {
        "slug": "deluxe-locker-abs-top",
        "name": "Deluxe Locker (ABS Top)",
        "img": "/products/deluxe-locker-abs-top-cut.png",
        "specs": [
          "3 sides enclosed with 1mm machine pressed CRCA sheet",
          "One having drawer & cabinet",
          "Upper top drawer & door made of ABS materials",
          "Mounted on 50mm grey castors",
          "Epoxy powder coated 8 tank process (by colour)",
          "Dimensions: L 400mm × W 400mm × H 800mm"
        ]
      },
      {
        "slug": "deluxe-bedside-locker-ss-top",
        "name": "Deluxe Bedside Locker (SS Top)",
        "img": "/products/deluxe-bedside-locker-ss-top-cut.png",
        "specs": [
          "3 sides enclosed with 1mm machine pressed CRCA sheet",
          "One having drawer & cabinet",
          "Upper top made of SS (Grade 304), 3 side railing",
          "Mounted on 50mm grey castors",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 400mm × W 400mm × H 800mm"
        ]
      },
      {
        "slug": "standard-bedside-locker",
        "name": "Standard Bedside Locker",
        "img": "/products/standard-bedside-locker-cut.png",
        "specs": [
          "3 sides enclosed with 1mm CRCA sheet",
          "One having drawer & cabinet",
          "Mounted on 50mm grey castors",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 400mm × W 400mm × H 800mm"
        ]
      },
      {
        "slug": "overbed-table-gear-mechanism",
        "name": "Overbed Table (Gear Mechanism)",
        "img": "/products/overbed-table-gear-mechanism-cut.png",
        "specs": [
          "Frame made of 19mm square pipe, thickness 1.6mm",
          "Heavy duty gear with SS handle",
          "Pillar made of 50mm square tube",
          "12mm water resistant laminated board in two parts",
          "Mounted on 50mm grey castors"
        ]
      }
    ]
  },
  {
    "id": "patient-care",
    "name": "Patient Care & Neonatal",
    "tab": "Neonatal",
    "tagline": "Incubators, resuscitation & phototherapy",
    "products": [
      {
        "slug": "intensive-care-baby-incubator",
        "name": "Intensive Care Baby Incubator",
        "img": "/products/intensive-care-baby-incubator-cut.png",
        "specs": [
          "Controller based on a micro-computerised system",
          "Large bright displays, easy to monitor and view from a distance",
          "Digital display system to measure the infant temperature",
          "Air temperature display and setting of the required temperature",
          "Feather touch keys for easy operation",
          "Bar graph LED system to indicate the heater output"
        ]
      },
      {
        "slug": "resuscitation-centre",
        "name": "Resuscitation Centre",
        "img": "/products/resuscitation-centre-cut.png",
        "specs": [
          "Self test system",
          "Auto / manual selection modes",
          "Air / skin servo controlled system",
          "°C / °F settings",
          "Heater power indicator",
          "LCD displays all fault indications",
          "Feather touch keys for easy operation",
          "Key pad lock facility",
          "Air / Skin / Manual / Pre-warm modes"
        ]
      },
      {
        "slug": "phototherapy",
        "name": "Phototherapy",
        "img": "/products/phototherapy-cut.png",
        "specs": [
          "Head tilt: top tray is tiltable and can be locked at any desired angle",
          "Height adjustment enables use with a variety of baby incubators, cribs and cots",
          "Digital timer: therapy time up to 99:59 hours, cumulative hours shown by default",
          "Medical grade LEDs, spectral output in the therapeutic range of 420 to 480 nm"
        ]
      },
      {
        "slug": "examination-couch",
        "name": "Examination Couch",
        "img": "/products/examination-couch-cut.png",
        "specs": [
          "3 sides enclosed by 1mm CRCA sheet",
          "3 drawers & 3 cabinets",
          "Head adjustable up to 60° by gas spring",
          "Upper laminated top with rexine foam mattress",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 1800mm × W 550mm × H 750mm"
        ]
      },
      {
        "slug": "bedside-curtain",
        "name": "Bedside Curtain",
        "img": "/products/bedside-curtain-cut.png",
        "specs": [
          "Curtain channel in “U” or “L” shape, aluminium anodised (25mm × 20mm)",
          "Curtain channel made of 16 gauge",
          "Curtain cloth made of polyester stain-proof fabric",
          "Provision for hanging with roller zipper",
          "Track accessories: joint clamp, channel hanging clamp, ceiling hanging clamp, channel joiner, side locking nut"
        ]
      }
    ]
  },
  {
    "id": "stretchers",
    "name": "Stretchers & Patient Transport",
    "tab": "Stretchers",
    "tagline": "Ambulance, scoop & hydraulic stretchers",
    "products": [
      {
        "slug": "ambulance-stretcher",
        "name": "Ambulance Stretcher",
        "img": "/products/ambulance-stretcher-cut.png",
        "specs": [
          "Utilises high precision mechanical transmission",
          "Folds automatically through the left and right hand control handle",
          "Made of high quality aluminium tube",
          "Castor diameter 125mm",
          "Suitable for hospitals, emergency centres, ambulances and field use",
          "Dimensions — High position: 1900mm × 560mm × 900mm · Low position: 1900mm × 560mm × 280mm"
        ]
      },
      {
        "slug": "scoop-stretcher",
        "name": "Scoop Stretcher",
        "img": "/products/scoop-stretcher-cut.png",
        "specs": [
          "Portable first aid stretcher",
          "Used for transporting bone fracture patients",
          "Divides into left and right parts"
        ]
      },
      {
        "slug": "hydraulic-stretcher-trolley",
        "name": "Hydraulic Stretcher Trolley",
        "img": "/products/hydraulic-stretcher-trolley-cut.png",
        "specs": [
          "Two section top, height adjustable by pneumatic pump",
          "Trendelenburg & Reverse Trendelenburg by gas spring",
          "Mounted on 125mm grey castors",
          "X-ray cassette holder under the platform",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 1980mm × W 600mm × H 700mm–900mm"
        ]
      }
    ]
  },
  {
    "id": "trolleys",
    "name": "Trolleys & Carts",
    "tab": "Trolleys",
    "tagline": "Crash carts, medicine & observation trolleys",
    "products": [
      {
        "slug": "crash-cart-trolley",
        "name": "Crash Cart Trolley",
        "img": "/products/crash-cart-trolley-cut.png",
        "specs": [
          "SS square frame",
          "Writing & working surface",
          "Upper tray is detachable",
          "Six drawers with central locking system",
          "Six colour bins fitted at the middle",
          "One examination LED light fitted at the top",
          "Mounted on 100mm medical castors, two with brakes",
          "Glossy polish",
          "Dimensions: L 900mm × W 400mm × H 1500mm"
        ]
      },
      {
        "slug": "medicine-trolley",
        "name": "Medicine Trolley",
        "img": "/products/medicine-trolley-cut.png",
        "specs": [
          "SS square frame",
          "Writing & working surface",
          "Six drawers which are unequal",
          "Six colour bins in three rows along with IV rod",
          "Mounted on 100mm medical castors, two with brakes",
          "Glossy polish",
          "Dimensions: L 750mm × W 450mm × H 1500mm"
        ]
      },
      {
        "slug": "sister-observation-trolley",
        "name": "Sister Observation Trolley",
        "img": "/products/sister-observation-trolley-cut.png",
        "specs": [
          "Column made of 25mm CRCA pipe (thickness 1.6mm)",
          "Upper sheet made of 1mm sheet",
          "Catheter holder, ampoule cutter & file holder",
          "Mounted on 100mm medical castor",
          "Finished with glossy polish",
          "Dimensions: L 660mm × W 630mm × H 940mm (front) / 1066mm (back)"
        ]
      },
      {
        "slug": "laparoscopy-trolley",
        "name": "Laparoscopy Trolley",
        "img": "/products/laparoscopy-trolley-cut.png",
        "specs": [
          "MS shelves with rail guard",
          "Suitable for keeping monitor",
          "Socket to receive 5/15 Amp – 230 V AC 3 pin plugs",
          "Mounted on 100mm grey castors",
          "Epoxy powder coated 8 tank process",
          "Dimensions: L 600mm × W 500mm × H 1500mm"
        ]
      }
    ]
  },
  {
    "id": "ot-tables",
    "name": "Operation Theatre Tables & Chairs",
    "tab": "OT Tables",
    "tagline": "C-Arm, ophthalmic & labour tables",
    "products": [
      {
        "slug": "c-arm-ot-table-electric-manual-six-function",
        "name": "C-Arm OT Table Electric + Manual (Six Function)",
        "img": "/products/c-arm-ot-table-electric-manual-six-function-cut.png",
        "specs": [
          "Square-base table with central locking castor",
          "Positions: height, tilt, Trendelenburg & Reverse Trendelenburg, flex & reflex, slide",
          "Five function with accessories",
          "Stainless fitting — detachable head, leg & pelvic section, in-built kidney bridge",
          "Five sectional radio-translucent top",
          "Dimensions: L 1800mm × W 525mm × H 750mm–1000mm"
        ]
      },
      {
        "slug": "c-arm-ot-table-actuator",
        "name": "C-Arm OT Table (Actuator)",
        "img": "/products/c-arm-ot-table-actuator-cut.png",
        "specs": [
          "Square-base table with floor locking castor",
          "Eccentric pillars",
          "Stainless fitting",
          "Detachable head, leg & pelvic section, in-built kidney bridge",
          "Five sectional radio-translucent top",
          "Base & cover made of easy-to-clean stainless steel",
          "Smooth, stepless articulation of the table top for precise patient positioning",
          "Standby battery back-up with recharging circuit"
        ]
      },
      {
        "slug": "c-arm-ot-table",
        "name": "C-Arm OT Table",
        "img": "/products/c-arm-ot-table-cut.png",
        "specs": [
          "T-base table",
          "Height adjustable pneumatic pump",
          "Trendelenburg & Reverse Trendelenburg, screw mechanism, kidney bridge position"
        ]
      },
      {
        "slug": "ot-table-side-control",
        "name": "OT Table (Side Control)",
        "img": "/products/ot-table-side-control-cut.png",
        "specs": [
          "T-base table",
          "Height adjustable by pneumatic pump",
          "Trendelenburg & Reverse Trendelenburg, kidney bridge position, screw mechanism",
          "Lithotomy, lateral & head side adjustable"
        ]
      },
      {
        "slug": "ophthalmic-operation-table",
        "name": "Ophthalmic Operation Table",
        "img": "/products/ophthalmic-operation-table-cut.png",
        "specs": [
          "Height range min./max. 640mm / 870mm",
          "Lifting speed 8 mm/s",
          "Total length 1880mm, total width 690mm",
          "Base size 825mm / 520mm",
          "Input 230 V 50/60 Hz, 110 V 50/60 Hz"
        ]
      },
      {
        "slug": "hydraulic-labour-table",
        "name": "Hydraulic Labour Table",
        "img": "/products/hydraulic-labour-table-cut.png",
        "specs": [
          "Height adjustable by hydraulic pump, head side adjustable up to 60°",
          "Lithotomy pads both sides",
          "Mounted on medical castor",
          "Dimensions: L 1800mm × W 700mm × H 700mm–900mm"
        ]
      },
      {
        "slug": "surgeon-chair",
        "name": "Surgeon Chair",
        "img": "/products/surgeon-chair-cut.png",
        "specs": [
          "Motorised precision & total physical support",
          "Ergonomic design, ideal for micro-surgery",
          "Noiseless German DC-motor height adjustment via foot switch",
          "Back support with smooth touching action & incline locking system",
          "Height adjustable back-rest",
          "Adjustable multi-position arm support",
          "Simultaneous locking of rear wheels",
          "Moulded seat with anti-static polyurethane cushion"
        ]
      }
    ]
  },
  {
    "id": "ot-lighting",
    "name": "OT Lighting & Medical Gas",
    "tab": "OT Lights",
    "tagline": "LED OT lights, spot lights & gas pendants",
    "products": [
      {
        "slug": "ot-led-light-4-dome-hexo",
        "name": "OT LED Light 4 Dome (Hexo)",
        "img": "/products/ot-led-light-4-dome-hexo-cut.png",
        "specs": [
          "Intensity: 100,000 Lux ± 10%",
          "Size of light field: 12–30 cm",
          "Colour temperature: 4000–5000 K",
          "Brightness control: capacitive touch panel",
          "No. of LEDs: 76",
          "Focusing: adjustable",
          "Colour rendering index: 93 RA",
          "LED life: > 50,000 hrs"
        ]
      },
      {
        "slug": "ot-led-light-4-4-dome-hexo",
        "name": "OT LED Light 4+4 Dome (Hexo)",
        "img": "/products/ot-led-light-4-4-dome-hexo-cut.png",
        "specs": [
          "Intensity: 100,000 + 100,000 Lux ± 10%",
          "Colour temperature: 4000–5000 K",
          "Size of light field: 12–30 cm",
          "No. of LEDs: 76 + 76",
          "Focusing: adjustable",
          "Colour rendering index: 93 RA",
          "LED life: > 50,000 hrs"
        ]
      },
      {
        "slug": "ot-led-light-4-dome-jupi",
        "name": "OT LED Light 4 Dome (Jupi)",
        "img": "/products/ot-led-light-4-dome-jupi-cut.png",
        "specs": [
          "Intensity: 130,000 Lux ± 10%",
          "Size of light field: 12–30 cm",
          "Colour temperature: 4000–5000 K",
          "Brightness control: capacitive touch panel",
          "No. of LEDs: 84",
          "Focusing: adjustable",
          "Colour rendering index: 93 RA",
          "LED life: > 50,000 hrs"
        ]
      },
      {
        "slug": "ot-led-light-4-4-dome-jupi",
        "name": "OT LED Light 4+4 Dome (Jupi)",
        "img": "/products/ot-led-light-4-4-dome-jupi-cut.png",
        "specs": [
          "Intensity: 130,000 + 130,000 Lux ± 10%",
          "Colour temperature: 4000–5000 K",
          "No. of LEDs: 84 + 84",
          "Size of light field: 12–30 cm",
          "Focusing: adjustable",
          "Colour rendering index: 93 RA",
          "LED life: > 50,000 hrs"
        ]
      },
      {
        "slug": "led-spot-light-21-led",
        "name": "LED Spot Light (21 LED)",
        "img": "/products/led-spot-light-21-led-cut.png",
        "specs": [
          "Intensity: 50,000 Lux ± 10%",
          "Colour temperature: 4800 K",
          "No. of LEDs: 21",
          "Size of light field: 12–30 cm",
          "Focusing: adjustable",
          "Colour rendering index: 93 RA",
          "LED life: > 50,000 hrs"
        ]
      },
      {
        "slug": "led-spot-light-7-led",
        "name": "LED Spot Light (7 LED)",
        "img": "/products/led-spot-light-7-led-cut.png",
        "specs": [
          "Intensity: 25,000 Lux ± 10%",
          "Colour temperature: 4800 K",
          "No. of LEDs: 7",
          "Size of light field: 12–30 cm",
          "Focusing: adjustable",
          "Colour rendering index: 93 RA",
          "LED life: > 50,000 hrs"
        ]
      },
      {
        "slug": "medical-gas-pendant",
        "name": "Medical Gas Pendant",
        "img": "/products/medical-gas-pendant-cut.png",
        "specs": [
          "Frame made of aluminium",
          "Oxygen, nitrous oxide, vacuum, air — 2 outlets each",
          "15mm dia along with 6 amp socket",
          "Single arm up to 360° rigid tap",
          "Finished with powder coating"
        ]
      }
    ]
  },
  {
    "id": "anaesthesia",
    "name": "Anaesthesia, Suction & Disinfection",
    "tab": "Anaesthesia",
    "tagline": "Boyle's apparatus, suction & fogging",
    "products": [
      {
        "slug": "boyle-s-apparatus",
        "name": "Boyle's Apparatus",
        "img": "/products/boyle-s-apparatus-cut.png",
        "specs": [
          "MS powder coated",
          "SS table top tray",
          "5\" dia braking castor",
          "Oxy locking N2O supply",
          "Oxygen and nitrous oxide gas inlet point, 2 nos. each",
          "230mm long rotameter for O2 & N2O with hypoxia guard",
          "Vaporiser — Halothane"
        ]
      },
      {
        "slug": "suction-machine",
        "name": "Suction Machine",
        "img": "/products/suction-machine-cut.png",
        "specs": [
          "Cabinet made of mild steel with epoxy powder coating",
          "1/2 HP heavy duty motor",
          "Oil immersed vacuum pump",
          "Two wide mouth glass bottles of approx. 1600ml each",
          "Overflow cut-off device",
          "Non-collapsible PVC tubing",
          "2.5\" dia vacuum gauge with vacuum control knob"
        ]
      },
      {
        "slug": "fogger-machine",
        "name": "Fogger Machine",
        "img": "/products/fogger-machine-cut.png",
        "specs": [
          "Digital timer device",
          "Liquid flow rate 1–3 ltr/hr",
          "Tank capacity 8 ltr",
          "Noise level < 8 dB @ 1 mtr"
        ]
      },
      {
        "slug": "fumigator",
        "name": "Fumigator",
        "img": "/products/fumigator-cut.png",
        "specs": [
          "SS body",
          "5 ltr tank capacity",
          "Volt: 220–230 V AC",
          "Motor: 1/8 HP"
        ]
      }
    ]
  },
  {
    "id": "sterilization",
    "name": "Sterilization & Cleaning",
    "tab": "Sterilizers",
    "tagline": "Steam, ETO & dry-heat sterilization",
    "products": [
      {
        "slug": "dressing-drum-wire-basket-tray",
        "name": "Dressing Drum & Wire Basket Tray",
        "img": "/products/dressing-drum-wire-basket-tray-cut.png",
        "specs": [
          "Drum made of stainless steel (Grade 304 quality)",
          "Spinning type pressed",
          "Movable belt with lock",
          "Finished with glossy polish"
        ]
      },
      {
        "slug": "horizontal-sterilizer",
        "name": "Horizontal Sterilizer",
        "img": "/products/horizontal-sterilizer-cut.png",
        "specs": [
          "Inner chamber, steam jacket, outer chamber and boiler made of heavy gauge stainless steel (Grade 304)",
          "All joints argon arc welded",
          "Radial locking lid made of thick SS plate",
          "Steam boiler fitted with water level indicator, pressure gauge, low water cut-off and automatic pressure control",
          "Sterilizing temperature settable at 121°C ± 5°C",
          "Universal PLC with user-friendly HMI front end"
        ]
      },
      {
        "slug": "automatic-horizontal-sterilizer",
        "name": "Automatic Horizontal Sterilizer",
        "img": "/products/automatic-horizontal-sterilizer-cut.png",
        "specs": [
          "Chamber size: 500mm (dia) × 1200mm (depth), 245 ltr",
          "Material: SS316L with full argon welding, thickness 4mm",
          "Design temperature: 134°C",
          "Operating pressure: 1.5 kg/cm² or 3.5 kg/cm²",
          "Hydro test: 5 kg/cm²"
        ]
      },
      {
        "slug": "vertical-sterilizer",
        "name": "Vertical Sterilizer",
        "img": "/products/vertical-sterilizer-cut.png",
        "specs": [
          "Hard rolled brass sheet / stainless steel “304” heavy gauge double container",
          "Withstands working pressure of 22 to 25 lbs per square inch",
          "Heavy cast gun metal / stainless steel lid & ring, chromium plated working parts",
          "Strong hinges, non-backing type round steam cock",
          "Pressure gauge and water level attachment with funnel",
          "Covered with mild steel / stainless steel"
        ]
      },
      {
        "slug": "automatic-horizontal-rectangular-sterilizer",
        "name": "Automatic Horizontal Rectangular Sterilizer",
        "img": "/products/automatic-horizontal-rectangular-sterilizer-cut.png",
        "specs": [
          "Inner chamber, steam jacket, outer chamber and boiler made of heavy gauge stainless steel (Grade 304)",
          "All joints argon arc welded",
          "Radial locking lid made of thick SS plate",
          "Steam boiler fitted with water level indicator, pressure gauge, low water cut-off and automatic pressure control",
          "Sterilizing temperature settable at 121°C ± 5°C",
          "Universal PLC with user-friendly HMI front end"
        ]
      },
      {
        "slug": "eto-sterilizer",
        "name": "ETO Sterilizer",
        "img": "/products/eto-sterilizer-cut.png",
        "specs": [
          "Chamber size: 300mm (W) × 300mm (H) × 1220mm (depth) — 130 litres",
          "Material: SS316L with full argon welding, thickness 4mm, mirror finished internal",
          "Design temperature: 44 to 55°C",
          "Vacuum: -0.85 bar, operating pressure negative",
          "Hydro test: 3 kg/cm²",
          "SS304 pressure gauge for humidifier",
          "Universal PLC with user-friendly HMI front end"
        ]
      },
      {
        "slug": "ultrasonic-cleaner",
        "name": "Ultrasonic Cleaner",
        "img": "/products/ultrasonic-cleaner-cut.png",
        "specs": [
          "Tank size: 600 × 350 × 200 mm, 30 ltr (L×W×D)",
          "Basket size: 480 × 330 × 150 mm",
          "Tank MOC: SS304, 16 G polished and buffed",
          "U/S power: 700 watts",
          "Operating frequency: 33 kHz ± 3 kHz",
          "Digital microprocessor based high frequency generator, timer 0–99 minutes",
          "Heater: 1200 watts, digital control up to 65°C, Degas + PSP + Timer modes"
        ]
      },
      {
        "slug": "hot-air-oven",
        "name": "Hot Air Oven",
        "img": "/products/hot-air-oven-cut.png",
        "specs": [
          "Temperature range: 5°C above ambient to 250°C maximum",
          "Temperature accuracy: ± 2°C, uniformity ± 1°C",
          "PID controller with LED display, PT-100 sensor",
          "Heating element: nichrome wire / Kanthal A1",
          "Over temperature protection and electric leakage breaker",
          "Temperature safety as per DIN 12880 Class 21"
        ]
      }
    ]
  },
  {
    "id": "scrub-stations",
    "name": "Scrub Stations",
    "tab": "Scrub",
    "tagline": "Sensor-operated stainless scrub bays",
    "products": [
      {
        "slug": "scrub-station-2-bay-mixture-sensor-operated",
        "name": "Scrub Station 2 Bay Mixture (Sensor Operated)",
        "img": "/products/scrub-station-2-bay-mixture-sensor-operated-cut.png",
        "specs": [
          "Four sides enclosed by 1.6mm",
          "Foot switch sensor based",
          "Drainage at the middle",
          "Glossy polish",
          "Sensor operated"
        ]
      },
      {
        "slug": "scrub-station-2-bay-4-operations",
        "name": "Scrub Station 2 Bay (4 Operations)",
        "img": "/products/scrub-station-2-bay-4-operations-cut.png",
        "specs": [
          "Four sides enclosed by 1.6mm SS sheet",
          "Infrared / hands-free water controls",
          "Foot, knee and elbow operated push panels in case of sensor / power failure",
          "Drainage at the middle",
          "Finished with glossy polish",
          "Dimensions: L 1800–2500mm × W 600–700mm × H 900–1100mm"
        ]
      }
    ]
  },
  {
    "id": "food-waiting",
    "name": "Food Service & Waiting Area",
    "tab": "Food & Waiting",
    "tagline": "Hot food trolleys & lobby seating",
    "products": [
      {
        "slug": "hot-food-trolley",
        "name": "Hot Food Trolley",
        "img": "/products/hot-food-trolley-cut.png",
        "specs": [
          "Three sides enclosed by 1mm (double wall)",
          "Inside glass or puff materials to reduce heat",
          "20 tray provision",
          "Mounted on 125mm castors",
          "1000 watt heater with regulator, light indicator, on/off switch and exhaust fan",
          "Four side railing raised at the top",
          "Push handle fitted on the right side",
          "Finished with glossy polish"
        ]
      },
      {
        "slug": "bain-marie-trolley",
        "name": "Bain Marie Trolley",
        "img": "/products/bain-marie-trolley-cut.png",
        "specs": [
          "Made of SS (Grade 304)",
          "5 containers",
          "Electrically operated",
          "Mounted on 100mm to 150mm medical castors",
          "Finished with glossy polish"
        ]
      },
      {
        "slug": "lobby-chair-4-seater",
        "name": "Lobby Chair (4 Seater)",
        "img": "/products/lobby-chair-4-seater-cut.png",
        "specs": [
          "Length: 1750mm, seat height: 450mm, width: 450mm",
          "Seat: SS thickness 1.5mm, back height: 890mm",
          "Pipe: 50mm round, 1.5mm thick",
          "Bash plate: 400mm × 125mm × 8mm"
        ]
      },
      {
        "slug": "lobby-chair-3-seater",
        "name": "Lobby Chair (3 Seater)",
        "img": "/products/lobby-chair-3-seater-cut.png",
        "specs": [
          "Length: 1750mm, seat height: 460mm, width: 450mm",
          "Seat: SS thickness 1.5mm, back height: 890mm",
          "Pipe: 50mm round, 1.5mm thick",
          "Bash plate: 400mm × 125mm × 8mm"
        ]
      }
    ]
  },
  {
    "id": "mortuary",
    "name": "Mortuary & Wall Panels",
    "tab": "Mortuary",
    "tagline": "Autopsy tables, cadaver tanks & bed head panels",
    "products": [
      {
        "slug": "autopsy-table",
        "name": "Autopsy Table",
        "img": "/products/autopsy-table-cut.png",
        "specs": [
          "Material: stainless steel",
          "Rectangular dissecting table",
          "Matte finish, dotted pattern",
          "Number of faucets: 4",
          "Dimensions: 96\" L × 30\" W × 32\" H"
        ]
      },
      {
        "slug": "cadaver-tank",
        "name": "Cadaver Tank",
        "img": "/products/cadaver-tank-cut.png",
        "specs": [
          "Stainless steel table covers with heavy grade hinge",
          "Lever handle waste outlet",
          "Dual end operated lift device to raise and lower perforated cadaver platform",
          "5 inch swivel castors",
          "Finished with glossy polish"
        ]
      },
      {
        "slug": "bed-head-panel",
        "name": "Bed Head Panel",
        "img": "/products/bed-head-panel-cut.png",
        "specs": [
          "Material: extruded aluminium",
          "Thickness: 6mm",
          "Outlet provision as per customer requirement"
        ]
      }
    ]
  }
];
